document.addEventListener('DOMContentLoaded', function () {
  if (window.__aurScriptsInit) return;
  window.__aurScriptsInit = true;
  initRevealsAur();
  initMarquesinasAur();
  initGaleriaProductoAur();
  initCantidadAur();
  initParallaxAur();
  initVisor360Aur();
  initEnvioEstimadoAur();
  initStickyCartAur();
  initAcordeonAur();
  initAhorroCantidadAur();
  initPrecioCantidadAur();
  initEstrellasFormAur();
  initExitPopupAur();
  initRegaloToggleAur();
  initComprarYaAur();
  initLineaTiempoAur();
  initSelectorIdiomaAur();
  initCarruselMomentosAur();
});

function initCarruselMomentosAur() {
  document.querySelectorAll('[data-aur-mc]').forEach(function (escenario) {
    var cards = Array.prototype.slice.call(escenario.querySelectorAll('[data-aur-mc-card]'));
    var n = cards.length;
    if (!n) return;
    var activo = 0;
    var segundos = parseInt(escenario.getAttribute('data-aur-mc-auto'), 10) || 0;
    var timer = null;
    var visible = true;

    function offsetDe(i) {
      var o = (((i - activo) % n) + n) % n;
      if (o > n / 2) o -= n;
      return o;
    }

    function reproducir(v) {
      var p = v.play();
      if (p && p.catch) p.catch(function () {});
    }

    function render() {
      cards.forEach(function (card, i) {
        var o = offsetDe(i);
        card.setAttribute('data-offset', Math.abs(o) <= 2 ? String(o) : 'lejos');
        var v = card.querySelector('video');
        if (!v) return;
        if (o === 0) {
          if (visible) reproducir(v);
        } else {
          v.pause();
        }
      });
    }

    function pararTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function iniciarTimer() {
      pararTimer();
      if (segundos < 1 || n < 2) return;
      timer = setInterval(function () {
        if (visible) ir(activo + 1, true);
      }, segundos * 1000);
    }

    function ir(k, sinReiniciar) {
      activo = ((k % n) + n) % n;
      render();
      if (!sinReiniciar) iniciarTimer();
    }

    cards.forEach(function (card, i) {
      card.addEventListener('click', function () {
        var o = offsetDe(i);
        if (o !== 0) ir(activo + o);
      });
    });

    var prev = escenario.querySelector('[data-aur-mc-prev]');
    var next = escenario.querySelector('[data-aur-mc-next]');
    if (prev) prev.addEventListener('click', function () { ir(activo - 1); });
    if (next) next.addEventListener('click', function () { ir(activo + 1); });

    escenario.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') ir(activo - 1);
      else if (e.key === 'ArrowRight') ir(activo + 1);
    });

    var x0 = null;
    escenario.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    escenario.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      x0 = null;
      if (Math.abs(dx) > 40) ir(activo + (dx < 0 ? 1 : -1));
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entradas) {
        visible = entradas[0].isIntersecting;
        if (visible) render();
        else cards.forEach(function (c) { var v = c.querySelector('video'); if (v) v.pause(); });
      }, { threshold: 0.25 }).observe(escenario);
    }

    ir(0);
  });
}

function initLineaTiempoAur() {
  document.querySelectorAll('[data-aur-timeline]').forEach(function (el) {
    var diasPrep = parseInt(el.getAttribute('data-dias-prep'), 10) || 1;
    var diasMin = parseInt(el.getAttribute('data-dias-min'), 10) || 2;
    var diasMax = parseInt(el.getAttribute('data-dias-max'), 10) || 5;
    var prepEl = el.querySelector('[data-aur-timeline-prep]');
    var entregaEl = el.querySelector('[data-aur-timeline-entrega]');
    var opciones = { day: 'numeric', month: 'short' };

    if (prepEl) {
      var fechaPrep = new Date();
      fechaPrep.setDate(fechaPrep.getDate() + diasPrep);
      prepEl.textContent = fechaPrep.toLocaleDateString('es-ES', opciones);
    }
    if (entregaEl) {
      var fechaMin = new Date();
      fechaMin.setDate(fechaMin.getDate() + diasMin);
      var fechaMax = new Date();
      fechaMax.setDate(fechaMax.getDate() + diasMax);
      entregaEl.textContent = fechaMin.toLocaleDateString('es-ES', opciones) + ' - ' + fechaMax.toLocaleDateString('es-ES', opciones);
    }
  });
}

function initRegaloToggleAur() {
  document.querySelectorAll('[data-aur-regalo-toggle]').forEach(function (check) {
    var campo = check.closest('form').querySelector('[data-aur-regalo-campo]');
    if (!campo) return;
    check.addEventListener('change', function () {
      campo.hidden = !check.checked;
    });
  });
}

function initComprarYaAur() {
  document.querySelectorAll('[data-aur-comprar-ya]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = btn.closest('form');
      if (!form) return;
      btn.disabled = true;
      var textoOriginal = btn.textContent;
      btn.textContent = '...';
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData, headers: { 'Accept': 'application/json' } })
        .then(function (res) {
          if (!res.ok) throw new Error('No se pudo añadir al carrito');
          return res.json();
        })
        .then(function () {
          window.location.href = '/checkout';
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = textoOriginal;
          form.requestSubmit ? form.requestSubmit() : form.submit();
        });
    });
  });
}

function initExitPopupAur() {
  var overlay = document.querySelector('[data-aur-exit-overlay]');
  if (!overlay) return;
  if (window.matchMedia('(max-width: 767px)').matches) return;
  if (sessionStorage.getItem('aurExitPopupMostrado')) return;

  var listo = false;
  setTimeout(function () { listo = true; }, 4000);

  function mostrar() {
    if (!listo || sessionStorage.getItem('aurExitPopupMostrado')) return;
    sessionStorage.setItem('aurExitPopupMostrado', '1');
    overlay.hidden = false;
    requestAnimationFrame(function () { overlay.classList.add('is-visible'); });
    document.removeEventListener('mouseout', alSalir);
  }

  function ocultar() {
    overlay.classList.remove('is-visible');
    setTimeout(function () { overlay.hidden = true; }, 300);
  }

  function alSalir(e) {
    if (e.clientY <= 0 && !e.relatedTarget && !e.toElement) mostrar();
  }

  document.addEventListener('mouseout', alSalir);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) ocultar();
  });
  var btnCerrar = overlay.querySelector('[data-aur-exit-cerrar]');
  if (btnCerrar) btnCerrar.addEventListener('click', ocultar);
}

function initEstrellasFormAur() {
  document.querySelectorAll('[data-aur-estrellas-input]').forEach(function (grupo) {
    var botones = grupo.querySelectorAll('[data-valor]');
    var numero = grupo.querySelector('[data-aur-estrellas-numero]');
    var input = grupo.parentElement ? grupo.parentElement.querySelector('[data-aur-estrellas-valor]') : null;

    function pintar(valor) {
      botones.forEach(function (btn) {
        var v = parseInt(btn.getAttribute('data-valor'), 10);
        var svg = btn.querySelector('svg');
        if (v <= valor) {
          svg.setAttribute('fill', 'var(--aur-color-acento)');
        } else {
          svg.setAttribute('fill', 'none');
        }
      });
      if (numero) numero.textContent = valor + '/5';
    }

    botones.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var valor = parseInt(btn.getAttribute('data-valor'), 10);
        if (input) input.value = valor;
        pintar(valor);
      });
    });
  });
}

function initAhorroCantidadAur() {
  document.querySelectorAll('[data-aur-ahorro]').forEach(function (contenedor) {
    var form = contenedor.closest('form');
    var input = form ? form.querySelector('[data-aur-qty-input]') : null;
    contenedor.querySelectorAll('[data-aur-ahorro-op]').forEach(function (item) {
      item.addEventListener('click', function () {
        contenedor.querySelectorAll('[data-aur-ahorro-op]').forEach(function (o) { o.classList.remove('is-active'); });
        item.classList.add('is-active');
        if (input) {
          input.value = item.getAttribute('data-qty');
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    });
    if (input) {
      input.addEventListener('change', function () {
        var val = input.value;
        contenedor.querySelectorAll('[data-aur-ahorro-op]').forEach(function (o) {
          o.classList.toggle('is-active', o.getAttribute('data-qty') === val);
        });
      });
    }
  });
}

function initPrecioCantidadAur() {
  var info = document.querySelector('[data-aur-precio-info]');
  var input = document.querySelector('[data-aur-qty-input]');
  if (!info || !input) return;

  var precio = parseInt(info.getAttribute('data-precio'), 10) || 0;
  var precioDesc = parseInt(info.getAttribute('data-precio-desc'), 10) || precio;
  var comparar = parseInt(info.getAttribute('data-comparar'), 10) || 0;
  var formato = info.getAttribute('data-formato') || '{{amount}}';
  var actual = info.querySelector('[data-aur-precio-actual]');
  var tachado = info.querySelector('[data-aur-precio-tachado]');
  var destinos = document.querySelectorAll('[data-aur-precio-btn]');

  function dinero(centimos) {
    var euros = centimos / 100;
    var conComa = euros.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var conPunto = euros.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return formato
      .replace('{{amount_with_comma_separator}}', conComa)
      .replace('{{amount_no_decimals}}', String(Math.round(euros)))
      .replace('{{amount}}', conPunto);
  }

  function actualizar() {
    var qty = Math.max(1, parseInt(input.value, 10) || 1);
    var total = qty >= 2 ? precioDesc * qty : precio;
    var antes = qty >= 2 ? precio * qty : comparar;
    if (actual) actual.textContent = dinero(total);
    if (tachado) {
      tachado.textContent = antes > total ? dinero(antes) : '';
      tachado.hidden = !(antes > total);
    }
    destinos.forEach(function (d) { d.textContent = dinero(total); });
  }

  input.addEventListener('change', actualizar);
  input.addEventListener('input', actualizar);
  actualizar();
}

function initEnvioEstimadoAur() {
  document.querySelectorAll('[data-aur-envio]').forEach(function (el) {
    var diasMin = parseInt(el.getAttribute('data-dias-min'), 10) || 2;
    var diasMax = parseInt(el.getAttribute('data-dias-max'), 10) || 5;
    var plantilla = el.getAttribute('data-plantilla') || '';
    var destino = el.querySelector('[data-aur-envio-texto]');
    if (!destino) return;

    var opciones = { day: 'numeric', month: 'long' };
    var fechaMin = new Date();
    fechaMin.setDate(fechaMin.getDate() + diasMin);
    var fechaMax = new Date();
    fechaMax.setDate(fechaMax.getDate() + diasMax);

    var texto = plantilla
      .replace('{fecha_min}', fechaMin.toLocaleDateString('es-ES', opciones))
      .replace('{fecha_max}', fechaMax.toLocaleDateString('es-ES', opciones));
    destino.innerHTML = texto;
  });
}

function initStickyCartAur() {
  var barra = document.querySelector('[data-aur-sticky-bar]');
  var gatillo = document.querySelector('[data-aur-sticky-gatillo]');
  if (!barra || !gatillo) return;

  var formularioPrincipal = document.querySelector('[data-aur-form-principal]');
  var botonBarra = barra.querySelector('[data-aur-sticky-btn]');
  if (botonBarra && formularioPrincipal) {
    botonBarra.addEventListener('click', function () {
      var botonPrincipal = formularioPrincipal.querySelector('button[type="submit"]');
      if (botonPrincipal) botonPrincipal.click();
    });
  }

  if (!('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        barra.classList.remove('is-visible');
      } else if (entry.boundingClientRect.top < 0) {
        barra.classList.add('is-visible');
      } else {
        barra.classList.remove('is-visible');
      }
    });
  }, { threshold: 0 });
  obs.observe(gatillo);
}

function initAcordeonAur() {
  document.querySelectorAll('[data-aur-acordeon-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.aur-acordeon-item');
      var panel = item.querySelector('.aur-acordeon-panel');
      var estaAbierto = item.classList.contains('is-open');

      item.parentElement.querySelectorAll('.aur-acordeon-item.is-open').forEach(function (otro) {
        if (otro !== item) {
          otro.classList.remove('is-open');
          otro.querySelector('.aur-acordeon-panel').style.maxHeight = null;
          otro.querySelector('[data-aur-acordeon-btn]').setAttribute('aria-expanded', 'false');
        }
      });

      if (estaAbierto) {
        item.classList.remove('is-open');
        panel.style.maxHeight = null;
        btn.setAttribute('aria-expanded', 'false');
      } else {
        item.classList.add('is-open');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
}

function initVisor360Aur() {
  var stages = document.querySelectorAll('[data-aur-360]');
  if (!stages.length) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  stages.forEach(function (stage) {
    var frames = stage.querySelectorAll('.aur-360-frame');
    var total = frames.length;
    if (!total) return;

    var current = 0;
    var dragging = false;
    var startX = 0;
    var accum = 0;
    var sensibilidad = 14;

    function irA(indice) {
      var i = ((indice % total) + total) % total;
      if (i === current) return;
      frames[current].classList.remove('is-active');
      frames[i].classList.add('is-active');
      current = i;
    }

    function marcarInteractuado() {
      stage.classList.add('is-interacted');
    }

    stage.addEventListener('pointerdown', function (e) {
      dragging = true;
      startX = e.clientX;
      accum = 0;
      if (stage.setPointerCapture) stage.setPointerCapture(e.pointerId);
      marcarInteractuado();
    });
    stage.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      startX = e.clientX;
      accum += dx;
      while (accum >= sensibilidad) { irA(current - 1); accum -= sensibilidad; }
      while (accum <= -sensibilidad) { irA(current + 1); accum += sensibilidad; }
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (ev) {
      stage.addEventListener(ev, function () { dragging = false; });
    });

    var wrap = stage.parentElement;
    var prevBtn = wrap ? wrap.querySelector('[data-aur-360-prev]') : null;
    var nextBtn = wrap ? wrap.querySelector('[data-aur-360-next]') : null;
    if (prevBtn) prevBtn.addEventListener('click', function () { marcarInteractuado(); irA(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { marcarInteractuado(); irA(current + 1); });

    if (!reduceMotion && 'IntersectionObserver' in window) {
      var demoHecho = false;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting && !demoHecho) {
            demoHecho = true;
            var paso = 0;
            var demoInterval = setInterval(function () {
              paso++;
              irA(paso);
              if (paso >= total) {
                clearInterval(demoInterval);
                irA(0);
              }
            }, 90);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      obs.observe(stage);
    }
  });
}

function initParallaxAur() {
  var els = document.querySelectorAll('[data-aur-parallax]');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var ticking = false;
  function actualizar() {
    els.forEach(function (el) {
      var rect = el.getBoundingClientRect();
      var centro = rect.top + rect.height / 2 - window.innerHeight / 2;
      var desplazamiento = Math.max(-36, Math.min(36, centro * -0.07));
      el.style.transform = 'translateY(' + desplazamiento + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      requestAnimationFrame(actualizar);
      ticking = true;
    }
  }, { passive: true });
  actualizar();
}

function initRevealsAur() {
  var els = document.querySelectorAll('.aur-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('aur-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-aur-delay') || 0;
        setTimeout(function () { entry.target.classList.add('aur-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initMarquesinasAur() {
  var wraps = document.querySelectorAll('[data-aur-marquesina]');
  wraps.forEach(function (wrap) {
    var track = wrap.querySelector('.aur-marquesina-track');
    if (!track || track.dataset.aurCloned) return;
    track.dataset.aurCloned = '1';
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    wrap.appendChild(clone);
  });
}

function initGaleriaProductoAur() {
  var thumbs = document.querySelectorAll('[data-aur-thumb]');
  if (!thumbs.length) return;
  var img = document.querySelector('[id^="aur-galeria-img-"]');
  var indiceActual = 0;
  var intervaloAur;

  function mostrarImagen(i) {
    var thumb = thumbs[i];
    if (!thumb || !img) return;
    img.src = thumb.getAttribute('data-full');
    img.alt = thumb.getAttribute('data-alt') || '';
    thumbs.forEach(function (t) { t.style.borderColor = 'transparent'; });
    thumb.style.borderColor = 'var(--aur-color-oscuro)';
    indiceActual = i;
  }

  function reiniciarAutoRotacion() {
    clearInterval(intervaloAur);
    if (thumbs.length < 2) return;
    intervaloAur = setInterval(function () {
      mostrarImagen((indiceActual + 1) % thumbs.length);
    }, 5000);
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () {
      mostrarImagen(i);
      reiniciarAutoRotacion();
    });
  });

  reiniciarAutoRotacion();
}

function initCantidadAur() {
  document.querySelectorAll('[data-aur-qty-menos]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-aur-qty-input]');
      var val = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });
  document.querySelectorAll('[data-aur-qty-mas]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = btn.parentElement.querySelector('[data-aur-qty-input]');
      var val = (parseInt(input.value, 10) || 1) + 1;
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });
}

function initSelectorIdiomaAur() {
  var wrap = document.querySelector('[data-aur-idioma]');
  if (!wrap) return;

  var btn = wrap.querySelector('[data-aur-idioma-btn]');
  var lista = wrap.querySelector('[data-aur-idioma-lista]');
  var etiqueta = wrap.querySelector('[data-aur-idioma-actual]');

  function nombreCorto(codigo) {
    if (!codigo || codigo === 'es') return 'ES';
    return codigo.slice(0, 2).toUpperCase();
  }

  function dispararEvento(el, tipo) {
    var evt;
    try {
      evt = new Event(tipo, { bubbles: true });
    } catch (err) {
      evt = document.createEvent('HTMLEvents');
      evt.initEvent(tipo, true, true);
    }
    el.dispatchEvent(evt);
  }

  var guardado = localStorage.getItem('aurIdioma') || 'es';
  etiqueta.textContent = nombreCorto(guardado);

  btn.addEventListener('click', function (e) {
    e.stopPropagation();
    var abierto = lista.hidden === false;
    lista.hidden = abierto;
    btn.setAttribute('aria-expanded', String(!abierto));
  });

  document.addEventListener('click', function (e) {
    if (!wrap.contains(e.target)) {
      lista.hidden = true;
      btn.setAttribute('aria-expanded', 'false');
    }
  });

  function aplicarIdioma(codigo) {
    lista.hidden = true;
    btn.setAttribute('aria-expanded', 'false');

    if (codigo === 'es') {
      localStorage.removeItem('aurIdioma');
      etiqueta.textContent = 'ES';
      var dominio = location.hostname.replace(/^www\./, '');
      document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.' + dominio;
      document.cookie = 'googtrans=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' + dominio;
      location.reload();
      return;
    }

    localStorage.setItem('aurIdioma', codigo);
    etiqueta.textContent = nombreCorto(codigo);
    var combo = document.querySelector('select.goog-te-combo');
    if (combo) {
      combo.value = codigo;
      dispararEvento(combo, 'change');
    }
  }

  function poblarLista(opciones) {
    lista.innerHTML = '';
    var itemEs = document.createElement('li');
    var btnEs = document.createElement('button');
    btnEs.type = 'button';
    btnEs.textContent = 'Español';
    btnEs.addEventListener('click', function () { aplicarIdioma('es'); });
    itemEs.appendChild(btnEs);
    lista.appendChild(itemEs);

    opciones.forEach(function (op) {
      if (!op.value || op.value === 'es') return;
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = op.text;
      b.addEventListener('click', function () { aplicarIdioma(op.value); });
      li.appendChild(b);
      lista.appendChild(li);
    });
  }

  window.googleTranslateElementInit = function () {
    new google.translate.TranslateElement({ pageLanguage: 'es', autoDisplay: false }, 'google_translate_element');
    var intentos = 0;
    var esperar = setInterval(function () {
      intentos++;
      var combo = document.querySelector('select.goog-te-combo');
      if (combo && combo.options.length > 1) {
        clearInterval(esperar);
        poblarLista(Array.prototype.slice.call(combo.options));
        var idiomaGuardado = localStorage.getItem('aurIdioma');
        if (idiomaGuardado) {
          combo.value = idiomaGuardado;
          dispararEvento(combo, 'change');
        }
      } else if (intentos > 40) {
        clearInterval(esperar);
      }
    }, 250);
  };

  var script = document.createElement('script');
  script.src = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
  document.body.appendChild(script);
}
